import { useState, type FC, type RefObject } from "react";
import { Presentation } from "./Presentation";
import { type JobEntry, type Option } from "./type";

const OTHER_REASON = "5";
const EMPLOYED_REJOB_REASON = "6";

type Props = {
  withdrawalReasonOptions: Option[];
  elementRef: RefObject<HTMLDivElement>;
  thinkingEntriesWithoutUserEmployed: JobEntry[];
};

export const EnqueteReasonInputs: FC<Props> = ({
  withdrawalReasonOptions,
  elementRef,
  thinkingEntriesWithoutUserEmployed,
}) => {
  const [selectedReason, setSelectedReason] = useState<string | undefined>();
  const [reasonText, setReasonText] = useState<string | undefined>();
  const [selectedEntryIds, setSelectedEntryIds] = useState<number[]>([]);

  const handleChangeSelectedReason = (value: string) => {
    setSelectedReason(value);
  };

  const handleReasonTextChange = (value: string) => {
    setReasonText(value);
  };

  const handleChangeSelectedEntryId = (entryId: number, isChecked: boolean) => {
    setSelectedEntryIds((prev) =>
      isChecked ? [...prev, entryId] : prev.filter((id) => id !== entryId),
    );
  };

  const isOtherSelected = selectedReason === OTHER_REASON;
  const isRejobEmploymentWithEntriesSelected =
    selectedReason === EMPLOYED_REJOB_REASON && thinkingEntriesWithoutUserEmployed.length > 0;
  const isValid = !(
    !selectedReason ||
    (isRejobEmploymentWithEntriesSelected && selectedEntryIds.length === 0)
  );

  return (
    <Presentation
      elementRef={elementRef}
      withdrawalReasonOptions={withdrawalReasonOptions}
      selectedReason={selectedReason}
      reasonText={reasonText}
      handleChangeSelectedReason={handleChangeSelectedReason}
      handleReasonTextChange={handleReasonTextChange}
      thinkingEntriesWithoutUserEmployed={thinkingEntriesWithoutUserEmployed}
      selectedEntryIds={selectedEntryIds}
      handleChangeSelectedEntryId={handleChangeSelectedEntryId}
      isOtherSelected={isOtherSelected}
      isValid={isValid}
      isRejobEmploymentWithEntriesSelected={isRejobEmploymentWithEntriesSelected}
    />
  );
};
